import { XCircle, CheckCircle } from "lucide-react";
import PlacaDisplay from "./PlacaDisplay";
const ConfirmationScreen = ({ onConfirm, onReject, placa }) => {
  return (
    <div className="flex flex-col items-center gap-4 w-full px-4">
      <PlacaDisplay placa={placa} />
      <p className="text-lg sm:text-xl text-center font-medium text-gray-700 mt-6 sm:mt-8 mb-4 sm:mb-6">
        Confirme se este veículo está na sua base:
      </p>
      <div className="flex flex-col sm:flex-row justify-center gap-4 w-full max-w-md mx-auto">
        <button
          onClick={onReject}
          className="group flex items-center justify-center gap-3 font-bold text-base sm:text-lg py-3 px-6 sm:px-8 rounded-lg shadow-lg bg-gradient-to-r from-red-500 to-red-600 text-white hover:scale-105 transition duration-200"
        >
          <XCircle size={20} className="sm:w-7 sm:h-7" />
          <span>Não Reconheço</span>
        </button>
        <button
          onClick={onConfirm}
          className="group flex items-center justify-center gap-3 font-bold text-base sm:text-lg py-3 px-6 sm:px-8 rounded-lg shadow-lg bg-gradient-to-r from-green-500 to-green-600 text-white hover:scale-105 transition duration-200"
        >
          <CheckCircle size={20} className="sm:w-7 sm:h-7" />
          <span>Confirmar Veículo</span>
        </button>
      </div>
    </div>
  );
};

export default ConfirmationScreen;
